/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {IDateUnits, IFilters, INode, RuleItem, RulesObj} from 'Components/flowChart/types';
import {configs, MODE, NODE_COLOR, NODE_COLOR_TYPE, NODE_STATE, STYLES} from './constant';
import {cloneDeep, union} from 'lodash';
import get from 'lodash/get';

export function checkIsNodeIfThen(type: string) {
	const isNodeIfThen =
		type === configs.NODE_TYPE_CONDITION_YES ||
		type === configs.NODE_TYPE_CONDITION_NO ||
		type === configs.NODE_TYPE_SPLIT_NODE ||
		type === configs.NODE_TYPE_SPLIT_NODE_CONTROL ||
		type === configs.WAIT_EVENT_HAPPENED ||
		type === configs.WAIT_EVENT_TIMEOUT ||
		type === configs.NODE_TYPE_WFR_NODE ||
		type === configs.NODE_TYPE_WFR_NODE_NO ||
		type === configs.ALLOCATE_COUPON_SUCCESS ||
		type === configs.ALLOCATE_COUPON_NOT_ENOUGH ||
		type === configs.ALLOCATE_COUPON_NOT_MATCH;

	return isNodeIfThen;
}

export function checkIsNodeIfThenParent(type: string) {
	const isNodeIfThen =
		type === configs.NODE_TYPE_IF_THEN ||
		type === configs.NODE_TYPE_IF_THEN_PARALLEL ||
		type === configs.NODE_TYPE_SPLIT ||
		type === configs.WAIT_EVENT ||
		type === configs.NODE_TYPE_WFR ||
		type === configs.ALLOCATE_COUPON;

	return isNodeIfThen;
}

export function checkIsBranch(type: string) {
	const isBranch =
		type === configs.NODE_TYPE_CONDITION_YES ||
		type === configs.NODE_TYPE_CONDITION_NO ||
		type === configs.NODE_TYPE_SPLIT_NODE ||
		type === configs.NODE_TYPE_SPLIT_NODE_CONTROL ||
		type === configs.WAIT_EVENT_HAPPENED ||
		type === configs.WAIT_EVENT_TIMEOUT ||
		type === configs.NODE_TYPE_WFR_NODE ||
		type === configs.NODE_TYPE_WFR_NODE_NO ||
		type === configs.ALLOCATE_COUPON_SUCCESS ||
		type === configs.ALLOCATE_COUPON_NOT_ENOUGH ||
		type === configs.ALLOCATE_COUPON_NOT_MATCH;

	return isBranch;
}

export function checkIsCopyable(type: string) {
	const isCopyable =
		type === configs.NODE_TYPE_CONDITION_YES ||
		type === configs.NODE_TYPE_SPLIT_NODE ||
		type === configs.NODE_TYPE_WFR_NODE;

	return isCopyable;
}

export function checkIsHiddenBadge(type: string) {
	const isHidden =
		type === configs.NODE_TYPE_CONDITION_NO ||
		type === configs.NODE_TYPE_CONDITION_YES ||
		type === configs.NODE_TYPE_SPLIT_NODE ||
		type === configs.NODE_TYPE_SPLIT_NODE_CONTROL ||
		type === configs.WAIT_EVENT_HAPPENED ||
		type === configs.WAIT_EVENT_TIMEOUT ||
		type === configs.NODE_TYPE_WFR_NODE ||
		type === configs.NODE_TYPE_WFR_NODE_NO ||
		type === configs.ALLOCATE_COUPON_SUCCESS ||
		type === configs.ALLOCATE_COUPON_NOT_ENOUGH ||
		type === configs.ALLOCATE_COUPON_NOT_MATCH;

	return isHidden;
}

export function checkIsSmallSpacingNodeIfThen(type: string, mode: string) {
	const isSmallSpacingNodeIfThen =
		(type === configs.NODE_TYPE_IF_THEN ||
			type === configs.NODE_TYPE_IF_THEN_PARALLEL ||
			type === configs.NODE_TYPE_SPLIT ||
			type === configs.WAIT_EVENT ||
			type === configs.NODE_TYPE_WFR ||
			type === configs.ALLOCATE_COUPON) &&
		mode === MODE.VIEW;

	return isSmallSpacingNodeIfThen;
}

export function checkIsSmallSpacingBranch(type: string, mode: string) {
	const isSmallSpacingBranch =
		(type === configs.NODE_TYPE_CONDITION_YES ||
			type === configs.NODE_TYPE_CONDITION_NO ||
			type === configs.NODE_TYPE_SPLIT_NODE ||
			type === configs.NODE_TYPE_SPLIT_NODE_CONTROL ||
			type === configs.WAIT_EVENT_HAPPENED ||
			type === configs.WAIT_EVENT_TIMEOUT ||
			type === configs.NODE_TYPE_WFR_NODE ||
			type === configs.NODE_TYPE_WFR_NODE_NO ||
			type === configs.ALLOCATE_COUPON_SUCCESS ||
			type === configs.ALLOCATE_COUPON_NOT_ENOUGH ||
			type === configs.ALLOCATE_COUPON_NOT_MATCH) &&
		mode === MODE.VIEW;

	return isSmallSpacingBranch;
}

export const findBranch = (node: any, parentId: string) => {
	if (node.type === 'END') {
		return node;
	}

	for (const item of node.branchs) {
		if (item.nodeId === parentId) {
			return item;
		} else if (item.branchs && item.branchs.length > 0) {
			return findBranch(item, parentId);
		}
	}
};

export const countFilterUniqueAttrs = (filters: IFilters): number => {
	try {
		const set = new Set();

		for (const {AND} of filters.OR) {
			for (const {column} of AND) {
				if (column) {
					set.add(column);
				}
			}
		}

		return set.size;
	} catch (error) {
		return 0;
	}
};

export const countFilterSegments = (filters: IFilters): number => {
	try {
		const arr: string[] = [];

		for (const {AND} of filters.OR) {
			for (const {value} of AND) {
				if (Array.isArray(value)) {
					arr.push(...value);
				} else {
					arr.push(value);
				}
			}
		}

		return arr.length;
	} catch (error) {
		return 0;
	}
};

export const deltaToContent = (delta: number): string => {
	try {
		const units = deltaToUnits(delta);
		const content = unitsToContent(units);

		return content;
	} catch (error) {
		return '';
	}
};

export const deltaToUnits = (delta: number): IDateUnits => {
	try {
		const days = Math.floor(delta / (60 * 60 * 24));
		const hours = Math.floor((delta - days * 24 * 60 * 60) / (60 * 60));
		const minutes = Math.floor((delta - days * 60 * 60 * 24 - hours * 60 * 60) / 60);
		const seconds = delta - days * 60 * 24 * 60 - hours * 60 * 60 - minutes * 60;

		return {days, hours, minutes, seconds};
	} catch (error) {
		return {days: 0, hours: 0, minutes: 0, seconds: 0};
	}
};

export const unitsToContent = (units: IDateUnits): string => {
	try {
		const {days, hours, minutes, seconds} = units;
		const arrUnits: string[] = [];

		if (days > 0) {
			arrUnits.push(`${days}d`);
		}

		if (hours > 0) {
			arrUnits.push(`${hours}h`);
		}

		if (minutes > 0) {
			arrUnits.push(`${minutes}m`);
		}

		if (seconds > 0) {
			arrUnits.push(`${seconds}s`);
		}

		return `${arrUnits.join(' - ')}`;
	} catch (error) {
		return '';
	}
};

const getDefaultStyles = (nodeType = NODE_COLOR_TYPE.NORMAL, status = NODE_STATE.DEFAULT, key: string) => {
	return get(NODE_COLOR, [nodeType, status, key], NODE_COLOR.NORMAL[status]?.[key]);
};

export const getNodeStyles = ({
	nodeType,
	backgroundColor,
	borderColor,
	color,
	hoverColor,
	hoverBorder,
	activeBackgroundColor,
	activeColor,
	activeBorder,
	status
}) => ({
	backgroundColor: backgroundColor || getDefaultStyles(nodeType, status, STYLES.backgroundColor),
	border: `1px solid ${borderColor || getDefaultStyles(nodeType, status, STYLES.borderColor)}`,
	color: color || getDefaultStyles(nodeType, status, STYLES.color),

	hoverBackgroundColor: backgroundColor || getDefaultStyles(nodeType, NODE_STATE.HOVER, STYLES.backgroundColor),
	hoverBorder: `1px solid ${hoverBorder || getDefaultStyles(nodeType, NODE_STATE.HOVER, STYLES.borderColor)}`,
	hoverColor: hoverColor || getDefaultStyles(nodeType, NODE_STATE.HOVER, STYLES.color),

	activeBackgroundColor:
		activeBackgroundColor || getDefaultStyles(nodeType, NODE_STATE.ACTIVE, STYLES.backgroundColor),
	activeColor: activeColor || getDefaultStyles(nodeType, NODE_STATE.ACTIVE, STYLES.color),
	activeBorder: `2px solid ${activeBorder || getDefaultStyles(nodeType, NODE_STATE.ACTIVE, STYLES.borderColor)}`,

	errorBackgroundColor: getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.DEFAULT, STYLES.backgroundColor),
	errorHoverBorder: `1px solid ${getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.HOVER, STYLES.borderColor)}`,
	errorHoverColor: getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.HOVER, STYLES.color),
	errorActiveBackgroundColor: getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.ACTIVE, STYLES.backgroundColor),
	errorActiveBorder: `2px solid ${getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.ACTIVE, STYLES.borderColor)}`,
	errorActiveColor: getDefaultStyles(NODE_COLOR_TYPE.ERROR, NODE_STATE.ACTIVE, STYLES.color)
});

export const checkViolationByRules = (params: {rules: RulesObj; data: INode[]; nodeBefore: {id: string}}) => {
	let differenceRules: RuleItem[] = [],
		ruleBefore: RuleItem[] = [],
		ruleAfter: RuleItem[] = [];

	const data = cloneDeep(params.data) || [];

	// if (params.nodeBefore?.id === '1bi37') {
	// 	console.log(differenceRules);
	// }

	const findNodeHelper = (condition: (node: INode) => boolean) => {
		const matchedNode = data.find((n) => condition(n));

		if (matchedNode) {
			return Object.assign(matchedNode, {
				rule: params.rules[matchedNode.type]
			});
		}
	};

	const nodeBefore = findNodeHelper(({nodeId}) => nodeId === params.nodeBefore.id);
	const nodeAfter = findNodeHelper(({parentId}) => parentId === params.nodeBefore.id);

	if (data.length) {
		ruleBefore = nodeBefore?.rule?.after || [];
		ruleAfter = nodeAfter?.rule?.before || [];

		differenceRules = union(ruleBefore, ruleAfter);

		// rule for go to other action
		if (
			!data.some(
				(item) => item.type === configs.NODE_TYPE_IF_THEN || item.type === configs.NODE_TYPE_IF_THEN_PARALLEL
			)
		) {
			differenceRules = [...differenceRules, configs.NODE_TYPE_GO_TO_OTHER_ACTION];
		} else if (data.some((item) => item.parentId === params.nodeBefore.id)) {
			differenceRules = [...differenceRules, configs.NODE_TYPE_GO_TO_OTHER_ACTION];
		}
	} else {
		differenceRules = params.rules?.['init']?.after || [];
	}

	return (actingNode: {type: string}) =>
		differenceRules.some((rule) => {
			let isViolate = false;

			if (typeof rule === 'string') {
				isViolate = rule === actingNode.type;
			} else if (nodeBefore) {
				isViolate = rule.handler({actingNode, node: nodeBefore});
			}

			return isViolate;
		});
};
